import { axiosInstance as request } from '@api/rest.service'

const api = '/emailing'

/**
 * @description GET /emailingpreview/subscription-claims/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CLAIM = id => request.get(`${api}/preview/subscription-claims/${id}`)

/**
 * @description POST /emailing/send
 * @returns {AxiosPromise<any>}
 */
export const SEND_EMAIL = payload => request.post(`${api}/send`, payload)
